import { useRouter } from "next/router";
import { useMemo } from "react";

const useSearchWithQuery = <T>(): ((query: T) => void) => {
  const router = useRouter();
  const { asPath } = router;
  const pathname = useMemo(() => asPath.split("?")[0], [asPath]);
  const search = (query) => {
    // 不要なクエリパラメータを付けないため
    Object.keys(query).map((key) => {
      const value = query[key];

      if (!value) delete query[key];
    });

    router.push({
      pathname,
      query,
    });
  };

  return search;
};

export default useSearchWithQuery;
